import axios from "../../api/axiosInstance";
import { STATUS, extractErrorInfo } from "./sharedfunction";

/**
 * Get all permissions grouped by category/module based on scope
 * @param {Object} params - Parameters object
 * @param {string} params.scope - Scope to filter permissions (Org_Level, Project_Level, Super_Admin)
 * @returns {Promise<Object>} Response object with status, data/error, and message
 */
export async function getPermissionsByCategory({ scope } = {}) {
  try {
    if (!scope) {
      return {
        status: STATUS.ERROR,
        error: "Scope is required",
      };
    }

    // Validate scope value
    const validScopes = ["Org_Level", "Project_Level", "Super_Admin"];
    if (!validScopes.includes(scope)) {
      return {
        status: STATUS.ERROR,
        error: "Invalid scope value. Must be one of: Org_Level, Project_Level, Super_Admin",
      };
    }

    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/permission/getAll`,
      {
        params: { scope },
        withCredentials: true,
      }
    );

    if (response?.data?.success || response?.data?.status === "success") {
      return {
        status: STATUS.SUCCESS,
        data: response?.data?.data || [],
        message: response?.data?.message,
      };
    }

    return {
      status: STATUS.ERROR,
      error: response?.data?.message || response?.data?.error,
      errors: response?.data?.errors,
    };
  } catch (error) {
    console.error("Error fetching permissions:", error);
    return extractErrorInfo(error);
  }
}

